import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { reset_password_confirm } from '../actions/authAction';
import true_mark1 from '../assets/image/true_mark1.webp';

const ResetPasswordConfirm = ({ reset_password_confirm }) => {
  const [requestSent, setRequestSent] = useState(false);
  const [formData, setFormData] = useState({
    new_password: '',
    re_new_password: ''
  });
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const { uid, token } = useParams();
  const { new_password, re_new_password } = formData;

  const messageStyle = {
    color: isError ? 'red' : 'green'
  };

  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = e => {
    e.preventDefault();

    // 1. Validate password length
    if (new_password.length < 6) {
      setMessage('Your password must be at least 6 characters.');
      setIsError(true);
      return;
    }

    // 2. Validate passwords match
    if (new_password !== re_new_password) {
      setMessage('الرمزالسري غير متطابق');
      setIsError(true);
      return;
    }

    // 3. Dispatch reset and show success
    reset_password_confirm(uid, token, new_password, re_new_password);
    setMessage('Your password has been reset!');
    setIsError(false);
    setRequestSent(true);
  };

  if (requestSent) {
    return (
      <div className='reset-success'>
        <img
          className='image_mark'
          src={true_mark1}
          alt='Success mark'
          width={350}
          height={350}
        />
        <p className='reset-success-message'>تم تغيير كلمة السر بنجاح</p>
      </div>
    );
  }

  return (
    <div className='sign-warapper'>
      <div className='container-sign'>
        <p className='form-title'>انشاء كلمة مرور جديدة</p>
        {message && (
          <p className='confirm-message' style={messageStyle}>
            {message}
          </p>
        )}
        <form onSubmit={onSubmit}>
          <div className='input-container'>
            <p className='input-label'>كلمة المرور الجديدة</p>
            <input
              className='input'
              type='password'
              placeholder='كلمة مرور جديدة'
              name='new_password'
              value={new_password}
              onChange={onChange}
              required
            />
          </div>
          <div className='input-container'>
            <p className='input-label'>تأكيد كلمة المرور الجديدة</p>
            <input
              className='input'
              type='password'
              placeholder='تأكيد كلمة مرور جديدة'
              name='re_new_password'
              value={re_new_password}
              onChange={onChange}
              required
            />
          </div>
          <button type='submit' className='btn'>ارسال</button>
        </form>

      </div>
    </div>
  );
};

export default connect(null, { reset_password_confirm })(ResetPasswordConfirm);
